import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';

import { StatsVendorEditDialog } from '../../dialogs/stats.vendor.edit/stats.vendor.edit.dialog';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

import { StatsVendorItemsDialog } from '../../dialogs/stats.vendor.items/stats.vendor.items.dialog';
import { ssApiService } from '../../services/ss-api.service';
import { VendorArray, Vendor } from '../../models/domain/vendor';
import { SelectItem } from 'primeng/primeng';
import { VendorStatisticsRequest } from '../../models/ss-api/requests/vendor.statistics.request';
import { VendorStatisticsItemArray } from '../../models/ss-api/responses/vendor.statistics.response';
import { SendVendorStatsEmailRequest } from '../../models/ss-api/requests/send.vendor.stats.email.request';
import { GlobalService } from '../../services/global.service';
import { ExportDataManager } from '../../managers/export.data.manager';
import { StatsVendorEmailDialog } from '../../dialogs/stats.vendor.email/stats.vendor.email.dialog';
import { SortBot } from '../../helpers/sort';


@Component({
    selector: 'app-vendor-stats',
    templateUrl: './vendor.stats.component.html',
    styleUrls: ['./vendor.stats.component.css']
})
export class VendorStatsComponent implements OnInit {

    IsBusy: boolean = false;
    Title: string = 'Vendor Partner Statistics';
    isActiveTest: boolean = true;
    indexACTIVE: number = 0;
    Vendors: VendorArray = new VendorArray();
    VendorFilter: string;

    // VENDOR REPORTS
    vendorOptions: SelectItem[] = [];
    selectedVendorOption: number;

    StartDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    EndDate: Date = new Date();

    ReportFilter: string;

    VendorStats: VendorStatisticsItemArray = new VendorStatisticsItemArray();

    constructor(private dialogService: DialogService, private api: ssApiService, private sweetAlertService: SweetAlertService, private gb: GlobalService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Vendor Statistics');
        this.getVendors();
    }

    sortBy(sortVar1, sortVar2?) {
        this.Vendors = SortBot.SortAuto(this.Vendors, sortVar1, sortVar2);
    }

    sortVendorStatsBy(sortVar1, sortVar2?) {
        this.VendorStats = SortBot.SortAuto(this.VendorStats, sortVar1, sortVar2);
    }

    getVendors() {

        this.IsBusy = true;

        let disposable = this.api.GetAllVendors().subscribe(response => {
            disposable.unsubscribe();
            this.IsBusy = false;

            this.Vendors = <VendorArray>response.Data.filter(x => {
                if (x.IsActive) return x;
            });
            this.Vendors = SortBot.SortAsc(this.Vendors, 'DisplayName');

            this.setUpVendors();
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    setUpVendors() {
        this.vendorOptions.push({ label: 'All Vendors', value: 0 });
        this.Vendors.forEach(x => {
            this.vendorOptions.push({ label: x.DisplayName, value: x.ID });
        });
        this.selectedVendorOption = this.vendorOptions[0].value;

    }

    addVendorDialog() {
        let disposable = this.dialogService.addDialog(StatsVendorEditDialog, {
            title: 'Add New',
            message: 'Confirm message'
        }, { width: 400, height: 350 }).subscribe(response => {
            disposable.unsubscribe();
        }, error => {
            disposable.unsubscribe();
        });
    }

    editVendorDialog(Item: Vendor) {
        let disposable = this.dialogService.addDialog(StatsVendorEditDialog, {
            title: 'Edit',
            message: 'Confirm message',
            Vendor: Item,
        }, { width: 400, height: 350 }).subscribe(response => {
            disposable.unsubscribe();
            this.getVendors();
        }, error => {
            disposable.unsubscribe();
        });
    }

    vendorItemsDialog(Item: Vendor) {
        let options = {
            width: 1000,
            height: 800
        };
        let disposable = this.dialogService.addDialog(StatsVendorItemsDialog, {
            Vendor: Item
        }, options).subscribe(response => {
            disposable.unsubscribe();
        }, error => {
            disposable.unsubscribe();
        });
    }

    EmailVendorReport() {
        // get the email
        let subscription = this.dialogService.addDialog(StatsVendorEmailDialog).subscribe(email => {
            subscription.unsubscribe();
            if (email == 'cancelled')
                return;
            // ok
            this.SendEmail(email);
        });

    }

    SendEmail(email: string) {

        // prepare request
        let request = new SendVendorStatsEmailRequest();
        request.Email = email;
        request.Search = this.getVendorStatsRequest();

        // ask and send
        this.sweetAlertService.swal({
            title: 'Email Vendor Report?',
            text: '',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, Send',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.api.VendorSendStatistics(request).toPromise();
            }
        })
            .then(
                async (response) => {

                    if (!response.Result) {
                        this.sweetAlertService.swal(
                            {
                                title: 'Error',
                                text: 'Error Sending Vendor Report',
                                type: 'error',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 1500
                            })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                        return;
                    }

                    // show confirmation
                    this.sweetAlertService.swal(
                        {
                            title: 'Success',
                            text: 'Email was succesfully sent',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then(() => {

                        }, () => { }); // keep this line to prevent promise error;

                },
                (dismiss) => {
                    if (dismiss === 'cancel') {

                        if (!confirm)
                            return;

                        // show cancelled
                        this.sweetAlertService.swal({
                            title: 'Cancelled',
                            text: 'Email not sent.',
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        }).then(() => {
                        }, () => { }); // keep this line to prevent promise error;
                    }
                }).catch(error => {
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: error.message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            // this.IsBusy = false;
                        }, (dismiss) => {
                            // this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                });

    }


    TabChanged(e: any) {
        this.indexACTIVE = e.index;
    }

    getVendorStatsRequest(): VendorStatisticsRequest {

        let request = new VendorStatisticsRequest;
        request.VendorID = this.selectedVendorOption;
        request.DateTimeStart = this.StartDate;
        request.DateTimeEnd = this.EndDate;

        return request;
    }

    GetTotalVendorCount() {
        let count = 0;
        this.VendorStats.forEach(function (stat) {
            count = count + stat.Count;
        });

        return count;
    }

    getVendorStats() {
        this.IsBusy = true;

        let request = this.getVendorStatsRequest();

        let disposable = this.api.VendorStatistics(request).subscribe(response => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.VendorStats = response.Data;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    ExportCSV() {
        let exporter = new ExportDataManager();
        exporter.ExportVendorStatistics(this.VendorStats, this.StartDate, this.EndDate);
    }



}
